import * as React from 'react';
import { Component } from 'react';
import { getFromHistory } from '../../../helpers/history';
import { History } from 'history';
import { SchoolAppChangePasswordForm2 } from './SchoolAppChangePasswordForm2';
import { SchoolAppResetPasswordForm2 } from './SchoolAppResetPasswordForm2';
import './SchoolAppResetPassword2.scss';
import { resetPasswordSchoolUsers, resetRequestPasswordSchoolUsers } from '../../../services/public/password';
import { SimpleModal } from '../../../components/SimpleModal/SimpleModal';

interface Props {
  history: History;
}

interface State {
  secretKey: string;
  isResetPasswordModalOpen: boolean;
  isChangePasswordModalOpen: boolean;
  promoEmailAgreement: boolean;
}

export class SchoolAppResetPassword2 extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      secretKey: undefined,
      isResetPasswordModalOpen: false,
      isChangePasswordModalOpen: false,
      promoEmailAgreement: undefined,
    };
  }

  componentDidMount(): void {
    const { history } = this.props;
    const secretKey = getFromHistory(history, 'secretKey');
    this.setState({ secretKey });
  }

  redirectToLoginPage = (): void => {
    const { history } = this.props;
    const { promoEmailAgreement } = this.state;

    history.push({
      pathname: '/login',
      search: '',
      state: { promoEmailAgreement },
    });
  };

  onChangePasswordFormSubmit = (data): void => {
    const { secretKey } = this.state;
    const { password, promoEmailAgreement } = data;

    resetPasswordSchoolUsers(password, secretKey).then(() => {
      this.setState({
        isChangePasswordModalOpen: true,
        promoEmailAgreement,
      });
    });
  };

  onResetPasswordFormSubmit = (data): void => {
    resetRequestPasswordSchoolUsers(data.email).then(() => {
      this.setState({
        isResetPasswordModalOpen: true,
      });
    });
  };

  renderResetPasswordModal(): React.ReactNode {
    const { isResetPasswordModalOpen } = this.state;
    return (
      <SimpleModal
        isOpen={isResetPasswordModalOpen}
        title={'Info'}
        body={'Please check your email inbox, and click the link in the email you received to reset your password.'}
        buttonText={'Ok'}
        onButtonClick={this.redirectToLoginPage}
      />
    );
  }

  renderChangePasswordModal(): React.ReactNode {
    const { isChangePasswordModalOpen } = this.state;
    return (
      <SimpleModal
        isOpen={isChangePasswordModalOpen}
        title={'Info'}
        body={'Password changed'}
        buttonText={'Ok'}
        onButtonClick={this.redirectToLoginPage}
      />
    );
  }

  render() {
    const { secretKey } = this.state;

    return (
      <div className={'bResetPasswordForm'}>
        {this.renderResetPasswordModal()}
        {this.renderChangePasswordModal()}
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="offset-xl-3 col-xl-6">
                <div className="mt-3 mb-3">
                  {secretKey ? (
                    <SchoolAppChangePasswordForm2
                      redirectToLoginPage={this.redirectToLoginPage}
                      onSubmit={this.onChangePasswordFormSubmit}
                    />
                  ) : (
                    <SchoolAppResetPasswordForm2
                      redirectToLoginPage={this.redirectToLoginPage}
                      onSubmit={this.onResetPasswordFormSubmit}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
